const ZIP_REGEX = /[0-9]{5}/g

export const validateZip = zip => {
    const match = zip.match(ZIP_REGEX);

    return !!match;
}